import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { MarkantElementsModule } from '@markant/elements-angular';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FormControlErrorPipe, FormControlKeyErrorPipe } from '@markant-platform/shared/util-pipes';
import { AdditionalOrgDataForm } from '../../upgrade-forms.config';
import { MarkantSelectOption } from '@markant-platform/shared/util-helpers';

@Component({
  selector: 'markant-platform-additional-org-data-form',
  templateUrl: './additional-org-data-form.component.html',
  styleUrls: ['./additional-org-data-form.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MarkantElementsModule,
    TranslocoModule,
    ReactiveFormsModule,
    FormControlKeyErrorPipe,
    FormControlErrorPipe,
  ],
})
export class AdditionalOrganizationDataFormComponent {
  form = input.required<AdditionalOrgDataForm>();
  mode = input.required<'read' | 'edit'>();

  showErrors = input<boolean>();

  billingLanguageOptions = this.getBillingLanguageOptions();
  billingLanguageRecord: Record<string, string> = this.billingLanguageOptions.reduce(
    (acc: Record<string, string>, option) => {
      acc[option.value] = option.representation;
      return acc;
    },
    {}
  );

  constructor(private readonly translocoService: TranslocoService) {}

  get billingLanguageControlOnReadonly(): FormControl<string> {
    return this.form().controls.billingLanguage as FormControl<string>;
  }

  private getBillingLanguageOptions(): MarkantSelectOption[] {
    return (this.translocoService.getAvailableLangs() as string[]).map(
      lang =>
        ({
          value: `${lang.slice(0, 2)}-${lang.slice(3).toLocaleUpperCase()}`,
          representation: this.translocoService.translate(`languageSelect.${lang}`),
        }) as MarkantSelectOption
    );
  }

  get masterKIN(): FormControl {
    return this.form().controls.masterKIN;
  }

  get billingLanguage(): FormControl {
    return this.form().controls.billingLanguage;
  }

  get billingEmail(): FormControl {
    return this.form().controls.billingEmail;
  }

  get isEditMode(): boolean {
    return this.mode() === 'edit';
  }
}
